import { render } from "./GoodkidLogo.vue?vue&type=template&id=8f4f2c2e&scoped=true"
import script from "./GoodkidLogo.vue?vue&type=script&lang=js"
export * from "./GoodkidLogo.vue?vue&type=script&lang=js"

import "./GoodkidLogo.vue?vue&type=style&index=0&id=8f4f2c2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f4f2c2e"]])

export default __exports__